// Setup namespaces for the Contact app
// 
// This keeps these classes and data out of the global scope and 
// reduces the risk of collision on the page accidentally.
(function (contact, undefined) {

    // Global namespaces defined
    contact.Controllers = {};
    contact.Services = {};

}(window.Contact = window.Contact || {}));